export const MAX_ACTIVE_BANNER_TITLE = 'Maximum of 5 Active Banners Reached';
export const MAX_ACTIVE_BANNER_MESSAGE =
  'Only five banners can be active at a time, and their periods must not overlap with those of new banners.';

/**
 * Checks whether an error from the backend indicates that the maximum of 5 active banners has been reached
 * or that the banner schedule overlaps with existing active banners.
 */
export function isMaxActiveBannersError(error: any): boolean {
  if (!error) return false;

  const messages: string[] = [];

  const addMsg = (val: any) => {
    if (!val) return;
    if (typeof val === 'string') {
      messages.push(val);
    } else if (typeof val === 'object') {
      if (typeof val.en === 'string') messages.push(val.en);
      if (typeof val.id === 'string') messages.push(val.id);
      if (typeof val.message === 'string') messages.push(val.message);
    }
  };

  addMsg(error?.response?.data?.response_schema?.response_message);
  addMsg(error?.response?.data?.response_output?.message);
  addMsg(error?.response?.data?.message);
  addMsg(error?.message);

  const fieldErrors = error?.response?.data?.response_output?.errors;
  if (Array.isArray(fieldErrors)) {
    fieldErrors.forEach((err: any) => {
      addMsg(err?.message);
    });
  }

  const combined = messages.join(' ').toLowerCase();

  return (
    (combined.includes('5') &&
      (combined.includes('banner') || combined.includes('aktif') || combined.includes('active')) &&
      (combined.includes('active') ||
        combined.includes('aktif') ||
        combined.includes('limit') ||
        combined.includes('reach') ||
        combined.includes('tercapai'))) ||
    combined.includes('active banner limit') ||
    combined.includes('maximum of 5 active banners') ||
    combined.includes('only five banners') ||
    (combined.includes('banner') && combined.includes('overlap'))
  );
}
